module.exports = __webpack_public_path__ + "static/media/joinedTournaments_30_40.65375962.png";